module.exports = __webpack_public_path__ + "img/freestyle_box25.a889eb75.jpg";